import { FC, SVGProps } from 'react'

export const IconOnlineSearchMenu: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.3335 18.3332H15.0002C15.4422 18.3332 15.8661 18.1576 16.1787 17.845C16.4912 17.5325 16.6668 17.1085 16.6668 16.6665V6.24984L12.0835 1.6665H5.00016C4.55814 1.6665 4.13421 1.8421 3.82165 2.15466C3.50909 2.46722 3.3335 2.89114 3.3335 3.33317V5.83317"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6665 1.6665V6.6665H16.6665"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.1665 14.1665C4.49481 14.1665 4.8199 14.1018 5.12321 13.9762C5.42653 13.8506 5.70212 13.6664 5.93427 13.4343C6.16642 13.2021 6.35057 12.9265 6.4762 12.6232C6.60184 12.3199 6.6665 11.9948 6.6665 11.6665C6.6665 11.3382 6.60184 11.0131 6.4762 10.7098C6.35057 10.4065 6.16642 10.1309 5.93427 9.89874C5.70212 9.66659 5.42653 9.48244 5.12321 9.3568C4.8199 9.23117 4.49481 9.1665 4.1665 9.1665C3.50346 9.1665 2.86758 9.4299 2.39874 9.89874C1.9299 10.3676 1.6665 11.0035 1.6665 11.6665C1.6665 12.3295 1.9299 12.9654 2.39874 13.4343C2.86758 13.9031 3.50346 14.1665 4.1665 14.1665Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.5 15L6.25 13.75" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
